(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar   = document.querySelector('[data-announcement-bar]');
    var close = document.querySelector('[data-announcement-close]');
    var KEY   = 'fortuneo-ann-closed-' + (bar ? bar.dataset.sectionId : '');

    if (!bar) return;

    if (sessionStorage.getItem(KEY)) {
      bar.style.display = 'none';
      return;
    }

    if (close) {
      close.addEventListener('click', function () {
        bar.style.height = bar.offsetHeight + 'px';
        requestAnimationFrame(function () {
          bar.style.transition = 'height 0.25s ease, opacity 0.25s ease';
          bar.style.height = '0';
          bar.style.opacity = '0';
          bar.style.overflow = 'hidden';
        });
        bar.addEventListener('transitionend', function () {
          bar.style.display = 'none';
        }, { once: true });
        sessionStorage.setItem(KEY, '1');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
(function () {
  var slider   = document.querySelector('[data-ba-slider]');
  var before   = document.querySelector('[data-ba-before]');
  var handle   = document.querySelector('[data-ba-handle]');

  if (!slider || !before) return;

  var isDragging = false;

  function setPosition(x) {
    var rect = slider.getBoundingClientRect();
    var pct  = Math.min(100, Math.max(0, ((x - rect.left) / rect.width) * 100));
    var val  = pct.toFixed(2) + '%';
    slider.style.setProperty('--ba-split', val);
    before.style.width = val;
    if (handle) handle.style.left = val;
  }

  slider.addEventListener('pointerdown', function (e) {
    isDragging = true;
    slider.classList.add('is-dragging');
    slider.setPointerCapture(e.pointerId);
    setPosition(e.clientX);
  });

  slider.addEventListener('pointermove', function (e) {
    if (!isDragging) return;
    setPosition(e.clientX);
  });

  slider.addEventListener('pointerup', function () {
    isDragging = false;
    slider.classList.remove('is-dragging');
  });

  slider.addEventListener('pointercancel', function () {
    isDragging = false;
    slider.classList.remove('is-dragging');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var layout = document.querySelector('[data-cart-layout]');
    if (!layout) return;

    var subtotalEl = document.querySelector('[data-cart-subtotal]');
    var totalEl    = document.querySelector('[data-cart-total]');
    var headerCount = document.querySelector('[data-cart-count]');

    function formatMoney(cents) {
      return window.Theme.formatMoney(cents);
    }

    // ── Update via Cart AJAX API ──────────────────────────────────────────
    async function updateCart(key, quantity, itemRow) {
      try {
        var res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity })
        });
        if (!res.ok) throw new Error('Cart update failed');
        var cart = await res.json();

        if (quantity === 0) {
          // Animate row out then remove
          itemRow.style.transition = 'opacity 0.2s ease, max-height 0.3s ease';
          itemRow.style.maxHeight  = itemRow.offsetHeight + 'px';
          itemRow.style.overflow   = 'hidden';
          requestAnimationFrame(function () {
            itemRow.style.opacity   = '0';
            itemRow.style.maxHeight = '0';
            itemRow.style.paddingBlock = '0';
          });
          itemRow.addEventListener('transitionend', function () {
            itemRow.remove();
            // If no items left, reload to show empty state
            if (cart.item_count === 0) window.location.reload();
          }, { once: true });
        } else {
          // Update line price
          var lineItem = cart.items.find(function (i) { return i.key === key; });
          if (lineItem) {
            var linePriceEl = itemRow.querySelector('[data-line-price]');
            if (linePriceEl) linePriceEl.textContent = formatMoney(lineItem.final_line_price);
          }
        }

        // Update summary totals
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price);
        if (totalEl)    totalEl.textContent    = formatMoney(cart.total_price);

        // Update header cart count badge
        if (headerCount) {
          headerCount.textContent = cart.item_count;
          headerCount.classList.toggle('is-hidden', cart.item_count === 0);
        }
      } catch (err) {
        console.error('Cart error:', err);
        window.location.reload();
      }
    }

    // ── Debounce helper ───────────────────────────────────────────────────
    function debounce(fn, ms) {
      var t;
      return function () {
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function () { fn.apply(null, args); }, ms);
      };
    }

    // ── Bind events on each cart item ─────────────────────────────────────
    document.querySelectorAll('[data-cart-item]').forEach(function (row) {
      var key      = row.dataset.itemKey;
      var input    = row.querySelector('[data-qty-input]');
      var minusBtn = row.querySelector('[data-qty-minus]');
      var plusBtn  = row.querySelector('[data-qty-plus]');
      var removeBtns = row.querySelectorAll('[data-remove-item]');

      var debouncedUpdate = debounce(function (qty) {
        updateCart(key, qty, row);
      }, 400);

      minusBtn?.addEventListener('click', function () {
        var val = Math.max(0, (parseInt(input.value) || 1) - 1);
        input.value = val;
        debouncedUpdate(val);
      });

      plusBtn?.addEventListener('click', function () {
        var val = (parseInt(input.value) || 0) + 1;
        input.value = val;
        debouncedUpdate(val);
      });

      input?.addEventListener('change', function () {
        var val = Math.max(0, parseInt(input.value) || 0);
        input.value = val;
        debouncedUpdate(val);
      });

      removeBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          updateCart(key, 0, row);
        });
      });
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  var track = document.querySelector('[data-cc-track]');
  var prev  = document.querySelector('[data-cc-prev]');
  var next  = document.querySelector('[data-cc-next]');
  if (!track) return;

  var cardWidth = track.querySelector('.collection-card')
    ? track.querySelector('.collection-card').offsetWidth + 16
    : 276;

  prev?.addEventListener('click', function () {
    track.scrollBy({ left: -cardWidth * 2, behavior: 'smooth' });
  });
  next?.addEventListener('click', function () {
    track.scrollBy({ left: cardWidth * 2, behavior: 'smooth' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  var container = document.querySelector('[data-collection-tabs]');
  if (!container) return;

  var tabs   = container.querySelectorAll('[role="tab"]');
  var panels = container.querySelectorAll('[role="tabpanel"]');

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var id = tab.dataset.tab;

      tabs.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      panels.forEach(function (p) {
        p.classList.add('is-hidden');
      });

      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      var panel = container.querySelector('#ct-panel-' + id);
      if (panel) panel.classList.remove('is-hidden');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    var section  = document.querySelector('[data-collection-section]');
    var drawer   = document.querySelector('[data-filter-drawer]');
    var overlay  = document.querySelector('[data-overlay]');
    var filterToggle = document.querySelector('[data-filter-toggle]');
    var filterClose  = document.querySelector('[data-filter-close]');
    var sortSelect   = document.querySelector('[data-sort-select]');

    // ── Filter drawer ─────────────────────────────────────────────────────
    function openFilters() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.removeAttribute('aria-hidden');
      overlay.classList.add('is-visible');
      filterToggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      filterClose?.focus();
    }

    function closeFilters() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.classList.remove('is-visible');
      filterToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      filterToggle?.focus();
    }

    filterToggle?.addEventListener('click', openFilters);
    filterClose?.addEventListener('click', closeFilters);
    overlay?.addEventListener('click', closeFilters);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeFilters();
    });

    // ── Sort — redirect on change ─────────────────────────────────────────
    sortSelect?.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Animate open/close with max-height interpolation
    var section = document.currentScript.closest('.shopify-section');
    if (!section) return;

    section.querySelectorAll('.faq__item').forEach(function (item) {
      var answer = item.querySelector('.faq__answer');
      if (!answer) return;

      // Set initial max-height for items that start open
      if (item.open) {
        answer.style.maxHeight = answer.scrollHeight + 'px';
      } else {
        answer.style.maxHeight = '0';
        answer.style.transition = 'max-height 0.3s ease';
      }

      item.addEventListener('toggle', function () {
        if (item.open) {
          answer.style.maxHeight = answer.scrollHeight + 'px';
        } else {
          answer.style.maxHeight = '0';
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    // Elements
    const headerWrapper   = document.querySelector('[data-header-wrapper]');
    const menuToggle      = document.querySelector('[data-menu-toggle]');
    const menuClose       = document.querySelector('[data-menu-close]');
    const mobileMenu      = document.querySelector('[data-mobile-menu]');
    const overlay         = document.querySelector('[data-overlay]');
    const searchToggle    = document.querySelector('[data-search-toggle]');
    const searchClose     = document.querySelector('[data-search-close]');
    const searchBar       = document.querySelector('[data-search-bar]');
    const dropdownToggles = document.querySelectorAll('[data-mobile-dropdown-toggle]');

    // ── Sticky scroll effect ──────────────────────────────────────────────
    if (headerWrapper) {
      window.addEventListener('scroll', () => {
        headerWrapper.classList.toggle('is-scrolled', window.scrollY > 10);
      }, { passive: true });
    }

    // ── Mobile menu ───────────────────────────────────────────────────────
    function openMenu() {
      if (!mobileMenu) return;
      mobileMenu.classList.add('is-open');
      mobileMenu.removeAttribute('aria-hidden');
      overlay.classList.add('is-visible');
      menuToggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      menuClose?.focus();
    }

    function closeMenu() {
      if (!mobileMenu) return;
      mobileMenu.classList.remove('is-open');
      mobileMenu.setAttribute('aria-hidden', 'true');
      overlay.classList.remove('is-visible');
      menuToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      menuToggle?.focus();
    }

    menuToggle?.addEventListener('click', openMenu);
    menuClose?.addEventListener('click', closeMenu);

    // ── Mobile sub-dropdowns ──────────────────────────────────────────────
    dropdownToggles.forEach(btn => {
      btn.addEventListener('click', () => {
        const isExpanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!isExpanded));
        const subnav = btn.nextElementSibling;
        if (subnav) subnav.hidden = isExpanded;
      });
    });

    // ── Search ────────────────────────────────────────────────────────────
    function openSearch() {
      if (!searchBar) return;
      searchBar.removeAttribute('hidden');
      searchBar.setAttribute('aria-hidden', 'false');
      searchToggle.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => searchBar.querySelector('input')?.focus());
    }

    function closeSearch() {
      if (!searchBar) return;
      searchBar.setAttribute('hidden', '');
      searchBar.setAttribute('aria-hidden', 'true');
      searchToggle.setAttribute('aria-expanded', 'false');
      searchToggle?.focus();
    }

    searchToggle?.addEventListener('click', () => {
      searchBar?.hasAttribute('hidden') ? openSearch() : closeSearch();
    });
    searchClose?.addEventListener('click', closeSearch);

    // ── Dark mode toggle ──────────────────────────────────────────────────
    const themeToggle = document.querySelector('[data-theme-toggle]');
    if (themeToggle) {
      const html        = document.documentElement;
      const STORAGE_KEY = 'fortuneo-theme';
      const defaultMode = themeToggle.dataset.defaultMode || 'system';

      function applyTheme(mode) {
        if (mode === 'dark') {
          html.setAttribute('data-theme', 'dark');
          themeToggle.setAttribute('aria-pressed', 'true');
        } else {
          html.removeAttribute('data-theme');
          themeToggle.setAttribute('aria-pressed', 'false');
        }
      }

      function getPreferred() {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) return stored;
        if (defaultMode === 'dark') return 'dark';
        if (defaultMode === 'light') return 'light';
        // 'system'
        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
      }

      // Apply on load (no flash — also applied inline in theme.liquid)
      applyTheme(getPreferred());

      themeToggle.addEventListener('click', () => {
        const current = html.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
        const next    = current === 'dark' ? 'light' : 'dark';
        localStorage.setItem(STORAGE_KEY, next);
        applyTheme(next);
      });

      // React to OS preference changes
      window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', e => {
        if (!localStorage.getItem(STORAGE_KEY)) {
          applyTheme(e.matches ? 'dark' : 'light');
        }
      });
    }

    // ── Overlay closes everything ─────────────────────────────────────────
    overlay?.addEventListener('click', () => {
      closeMenu();
      closeSearch();
    });

    // ── Escape key ────────────────────────────────────────────────────────
    document.addEventListener('keydown', e => {
      if (e.key !== 'Escape') return;
      closeMenu();
      closeSearch();
      hideResults();
    });

    // ── Instant / Predictive Search ───────────────────────────────────────
    const searchInput   = document.querySelector('[data-search-input]');
    const searchResults = document.querySelector('[data-search-results]');

    if (searchInput && searchResults) {
      let controller = null;
      let focusIndex = -1;

      // i18n strings injected from Liquid via data-* on [data-header-wrapper]
      const headerWrapper = document.querySelector('[data-header-wrapper]');
      const i18nNoResultsTpl  = (headerWrapper && headerWrapper.dataset.i18nNoResultsHtml)  || 'No results for "<strong>__QUERY__</strong>"';
      const i18nBrowseAll     = (headerWrapper && headerWrapper.dataset.i18nBrowseAll)     || 'Browse all results →';
      const i18nLabelProducts = (headerWrapper && headerWrapper.dataset.i18nProducts)      || 'Products';
      const i18nLabelCols     = (headerWrapper && headerWrapper.dataset.i18nCollections)   || 'Collections';
      const i18nLabelPages    = (headerWrapper && headerWrapper.dataset.i18nPages)         || 'Pages';

      function escapeHtml(str) {
        return String(str).replace(/[&<>"']/g, s => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[s]));
      }

      function debounce(fn, ms) {
        let t;
        return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), ms); };
      }

      function showResults() {
        searchResults.removeAttribute('hidden');
        searchInput.setAttribute('aria-expanded', 'true');
      }

      function hideResults() {
        searchResults.setAttribute('hidden', '');
        searchInput.setAttribute('aria-expanded', 'false');
        focusIndex = -1;
      }

      // Predictive search returns `price` as a decimal string in major units
      // ("419.00"), unlike the Ajax cart API which uses cents.
      function formatMoney(majorUnits) {
        return window.Theme.formatMoney(Math.round(parseFloat(majorUnits) * 100));
      }

      function highlight(text, query) {
        if (!query) return text;
        const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        return text.replace(new RegExp(`(${escaped})`, 'gi'), '<mark>$1</mark>');
      }

      function renderResults(data, query) {
        const { products = [], collections = [], pages = [] } = data.resources?.results || {};

        if (!products.length && !collections.length && !pages.length) {
          const noResultsMsg = i18nNoResultsTpl.replace('__QUERY__', escapeHtml(query));
          searchResults.innerHTML = `<p class="search-results__empty">${noResultsMsg}</p>
            <a href="/search?q=${encodeURIComponent(query)}&type=product" class="search-results__all">${i18nBrowseAll}</a>`;
          showResults();
          return;
        }

        let html = '';

        // Products
        if (products.length) {
          html += '<div class="search-results__section">'
            + '<p class="search-results__label">' + i18nLabelProducts + '</p>';
          products.forEach(p => {
            const img   = p.image ? `<img class="search-results__item-img" src="${p.image}${p.image.includes('?') ? '&' : '?'}width=96" alt="${p.title}" width="48" height="48" loading="lazy">` : `<div class="search-results__item-img"></div>`;
            const price = p.price ? `<span class="search-results__item-price">${formatMoney(p.price)}</span>` : '';
            html += `<a class="search-results__item" href="${p.url}" role="option">
              ${img}
              <span class="search-results__item-info">
                <span class="search-results__item-title">${highlight(p.title, query)}</span>
                ${p.vendor ? `<span class="search-results__item-sub">${p.vendor}</span>` : ''}
              </span>
              ${price}
            </a>`;
          });
          html += '</div>';
        }

        // Collections
        if (collections.length) {
          html += '<div class="search-results__section">'
            + '<p class="search-results__label">' + i18nLabelCols + '</p>';
          collections.forEach(c => {
            html += `<a class="search-results__item" href="${c.url}" role="option">
              <span class="search-results__item-info">
                <span class="search-results__item-title">${highlight(c.title, query)}</span>
              </span>
            </a>`;
          });
          html += '</div>';
        }

        // Pages
        if (pages.length) {
          html += '<div class="search-results__section">'
            + '<p class="search-results__label">' + i18nLabelPages + '</p>';
          pages.forEach(pg => {
            html += `<a class="search-results__item" href="${pg.url}" role="option">
              <span class="search-results__item-info">
                <span class="search-results__item-title">${highlight(pg.title, query)}</span>
              </span>
            </a>`;
          });
          html += '</div>';
        }

        html += `<a href="/search?q=${encodeURIComponent(query)}&type=product" class="search-results__all">${i18nBrowseAll}</a>`;

        searchResults.innerHTML = html;
        showResults();
        bindResultsKeyboard();
      }

      function bindResultsKeyboard() {
        focusIndex = -1;
      }

      const fetchSuggestions = debounce(async (query) => {
        if (query.length < 2) { hideResults(); return; }

        if (controller) controller.abort();
        controller = new AbortController();

        searchResults.innerHTML = '<div class="search-results__loading">Searching…</div>';
        showResults();

        try {
          const res  = await fetch(
            `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,page&resources[limit]=5`,
            { signal: controller.signal }
          );
          if (!res.ok) throw new Error('Search failed');
          const data = await res.json();
          renderResults(data, query);
        } catch (err) {
          if (err.name !== 'AbortError') {
            hideResults();
          }
        }
      }, 250);

      searchInput.addEventListener('input', (e) => {
        fetchSuggestions(e.target.value.trim());
      });

      // Keyboard navigation
      searchInput.addEventListener('keydown', (e) => {
        const items = [...searchResults.querySelectorAll('.search-results__item, .search-results__all')];
        if (!items.length) return;

        if (e.key === 'ArrowDown') {
          e.preventDefault();
          focusIndex = Math.min(focusIndex + 1, items.length - 1);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          focusIndex = Math.max(focusIndex - 1, -1);
        } else if (e.key === 'Enter' && focusIndex >= 0) {
          e.preventDefault();
          items[focusIndex]?.click();
          return;
        }

        items.forEach((item, i) => item.classList.toggle('is-focused', i === focusIndex));
        if (focusIndex >= 0) items[focusIndex].scrollIntoView({ block: 'nearest' });
      });

      // Click outside closes results — and collapses the search bar
      document.addEventListener('click', (e) => {
        if (searchBar?.contains(e.target) || searchToggle?.contains(e.target)) return;
        hideResults();
        if (!searchBar?.hasAttribute('hidden')) closeSearch();
      });

      // Clear on search close
      searchClose?.addEventListener('click', () => {
        hideResults();
        searchInput.value = '';
        searchResults.innerHTML = '';
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-hotspots"] && !Shopify.designMode) return;
  try {
    
(function () {
  var wrap = document.querySelector('[data-hotspots]');
  if (!wrap) return;

  var activeId = null;

  wrap.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hotspot-trigger]');

    /* Click outside — close all */
    if (!btn) {
      closeAll();
      return;
    }

    var id = btn.dataset.hotspotTrigger;
    if (activeId === id) {
      closeAll();
    } else {
      closeAll();
      open(id);
    }
  });

  document.addEventListener('click', function (e) {
    if (!wrap.contains(e.target)) closeAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  function open(id) {
    activeId = id;
    var card = wrap.querySelector('#hotspot-card-' + id);
    var btn  = wrap.querySelector('[data-hotspot-trigger="' + id + '"]');
    var dot  = wrap.querySelector('[data-hotspot="' + id + '"]');
    if (card) {
      card.hidden = false;
      /* Flip card if near bottom of wrap */
      var rect = dot ? dot.getBoundingClientRect() : null;
      var wrapRect = wrap.getBoundingClientRect();
      if (rect && rect.top - wrapRect.top > wrapRect.height * 0.6) {
        dot.classList.add('hotspot--flip-down');
      }
    }
    if (btn) btn.setAttribute('aria-expanded', 'true');
  }

  function closeAll() {
    activeId = null;
    wrap.querySelectorAll('.hotspot__card').forEach(function (c) {
      c.hidden = true;
    });
    wrap.querySelectorAll('[data-hotspot-trigger]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
    wrap.querySelectorAll('[data-hotspot]').forEach(function (d) {
      d.classList.remove('hotspot--flip-down');
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  var el       = document.querySelector('[data-iwtc]');
  if (!el) return;

  var slides   = el.querySelectorAll('[data-iwtc-slide]');
  var dots     = el.querySelectorAll('[data-iwtc-dot]');
  var prevBtn  = el.querySelector('[data-iwtc-prev]');
  var nextBtn  = el.querySelector('[data-iwtc-next]');
  var total    = slides.length;
  var current  = 0;
  var autoplay = el.dataset.autoplay !== 'false';
  var interval = parseInt(el.dataset.interval) || 6000;
  var timer    = null;

  if (total < 2) return;

  function goTo(index) {
    slides[current].classList.remove('is-active');
    if (dots[current]) { dots[current].classList.remove('is-active'); dots[current].setAttribute('aria-selected', 'false'); }
    current = (index + total) % total;
    slides[current].classList.add('is-active');
    if (dots[current]) { dots[current].classList.add('is-active'); dots[current].setAttribute('aria-selected', 'true'); }
  }

  prevBtn && prevBtn.addEventListener('click', function () { goTo(current - 1); resetTimer(); });
  nextBtn && nextBtn.addEventListener('click', function () { goTo(current + 1); resetTimer(); });

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () { goTo(parseInt(dot.dataset.iwtcDot)); resetTimer(); });
  });

  /* Drag / swipe */
  var startX = 0;
  el.addEventListener('pointerdown', function (e) { startX = e.clientX; });
  el.addEventListener('pointerup', function (e) {
    var diff = startX - e.clientX;
    if (Math.abs(diff) > 50) { diff > 0 ? goTo(current + 1) : goTo(current - 1); resetTimer(); }
  });

  /* Autoplay */
  function startTimer() {
    if (!autoplay) return;
    timer = setInterval(function () { goTo(current + 1); }, interval);
  }
  function resetTimer() { clearInterval(timer); startTimer(); }

  el.addEventListener('mouseenter', function () { clearInterval(timer); });
  el.addEventListener('mouseleave', startTimer);

  startTimer();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-addresses]');
    if (!root) return;

    function setForm(key, open) {
      const form = root.querySelector('[data-address-form="' + key + '"]');
      if (form) form.hidden = !open;
    }

    root.querySelectorAll('[data-address-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => setForm(btn.dataset.addressToggle, true));
    });
    root.querySelectorAll('[data-address-cancel]').forEach((btn) => {
      btn.addEventListener('click', () => setForm(btn.dataset.addressCancel, false));
    });
    root.querySelectorAll('[data-address-delete]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        if (!window.confirm(btn.dataset.confirm)) e.preventDefault();
      });
    });

    // Pre-select the saved country on edit forms.
    root.querySelectorAll('select[data-default-country]').forEach((sel) => {
      const def = sel.getAttribute('data-default-country');
      if (def) sel.value = def;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  (function () {
    const root = document;
    const loginView = root.querySelector('[data-login-view]');
    const recoverView = root.querySelector('[data-recover-view]');
    if (!loginView || !recoverView) return;

    function show(recover) {
      loginView.hidden = recover;
      recoverView.hidden = !recover;
      if (recover) {
        const f = recoverView.querySelector('input[type="email"]');
        if (f) f.focus();
      }
    }

    root.querySelectorAll('[data-recover-toggle]').forEach((b) =>
      b.addEventListener('click', () => show(true))
    );
    root.querySelectorAll('[data-recover-cancel]').forEach((b) =>
      b.addEventListener('click', () => show(false))
    );

    // Shopify appends #recover (or recover form errors) — open recover view directly.
    if (window.location.hash === '#recover' || recoverView.querySelector('.form-status--error, .form-status--success')) {
      show(true);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  var grid    = document.querySelector('[data-media-grid]');
  var dialog  = document.querySelector('[data-mg-lightbox]');
  if (!grid || !dialog) return;

  var triggers = grid.querySelectorAll('[data-mg-trigger]');
  var lbWrap   = dialog.querySelector('[data-mg-lb-img-wrap]');
  var lbImg    = document.createElement('img');
  lbImg.className = 'mg-lightbox__img';
  lbImg.alt = '';
  lbWrap.insertBefore(lbImg, lbWrap.firstChild);
  var lbCap    = dialog.querySelector('[data-mg-lb-caption]');
  var closeBtn = dialog.querySelector('[data-mg-close]');
  var prevBtn  = dialog.querySelector('[data-mg-lb-prev]');
  var nextBtn  = dialog.querySelector('[data-mg-lb-next]');

  /* Build data array from DOM images */
  var items = Array.from(triggers).map(function (el) {
    var img = el.querySelector('img');
    var cap = el.querySelector('.mg-item__caption p');
    return {
      src: img ? img.src : '',
      alt: img ? img.alt : '',
      cap: cap ? cap.textContent : ''
    };
  });

  var current = 0;

  function open(index) {
    current = index;
    show();
    dialog.showModal();
  }

  function show() {
    lbImg.src = items[current].src;
    lbImg.alt = items[current].alt;
    lbCap.textContent = items[current].cap;
  }

  triggers.forEach(function (el) {
    el.addEventListener('click', function () {
      open(parseInt(el.dataset.mgTrigger));
    });
  });

  closeBtn.addEventListener('click', function () { dialog.close(); });
  prevBtn.addEventListener('click', function () {
    current = (current - 1 + items.length) % items.length;
    show();
  });
  nextBtn.addEventListener('click', function () {
    current = (current + 1) % items.length;
    show();
  });

  /* Close on backdrop click */
  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) dialog.close();
  });

  /* Keyboard navigation */
  dialog.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') { current = (current - 1 + items.length) % items.length; show(); }
    if (e.key === 'ArrowRight') { current = (current + 1) % items.length; show(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    

  (function () {
    var STORAGE_KEY = 'fortuneo-popup-dismissed';
    var POPUP_ID    = 'newsletter-popup';

    var popup   = document.getElementById(POPUP_ID);
    if (!popup) return;

    var DELAY_MS    = parseInt(popup.dataset.delayMs, 10) || 0;
    var RESHOW_DAYS = parseInt(popup.dataset.reshowDays, 10) || 0;
    var EXIT_INTENT = popup.dataset.exitIntent === 'true';

    /* ── Dismissal helpers ───────────────────────────────────────────────── */
    function isDismissed() {
      try {
        var val = localStorage.getItem(STORAGE_KEY);
        if (!val) return false;
        var expiry = parseInt(val, 10);
        return Date.now() < expiry;
      } catch (e) {
        return false;
      }
    }

    function markDismissed() {
      try {
        var expiry = Date.now() + RESHOW_DAYS * 24 * 60 * 60 * 1000;
        localStorage.setItem(STORAGE_KEY, String(expiry));
      } catch (e) {}
    }

    /* ── Open / close ────────────────────────────────────────────────────── */
    function openPopup() {
      if (isDismissed()) return;
      popup.removeAttribute('hidden');
      // Force reflow so transition plays
      popup.offsetHeight; // eslint-disable-line no-unused-expressions
      popup.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      // Focus first focusable element
      var firstInput = popup.querySelector('input[type="email"]');
      if (firstInput) {
        setTimeout(function () { firstInput.focus(); }, 350);
      }
    }

    function closePopup(permanent) {
      popup.classList.remove('is-open');
      document.body.style.overflow = '';
      if (permanent !== false) markDismissed();
      setTimeout(function () {
        popup.setAttribute('hidden', '');
      }, 400);
    }

    /* ── Triggers ────────────────────────────────────────────────────────── */
    if (!isDismissed()) {
      // Timed trigger
      if (DELAY_MS >= 0) {
        setTimeout(openPopup, DELAY_MS);
      }

      // Exit-intent trigger (desktop only)
      if (EXIT_INTENT && !('ontouchstart' in window)) {
        var exitFired = false;
        document.addEventListener('mouseleave', function (e) {
          if (exitFired || e.clientY > 10) return;
          exitFired = true;
          openPopup();
        }, { once: false });
      }
    }

    /* ── Close handlers ──────────────────────────────────────────────────── */
    popup.querySelectorAll('[data-popup-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        closePopup(true);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) {
        closePopup(true);
      }
    });

    /* ── Form submission → success state ────────────────────────────────── */
    var form = document.getElementById('newsletter-popup-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var emailInput = form.querySelector('input[type="email"]');
        var email = emailInput ? emailInput.value : '';
        if (!email) return;

        // Submit via fetch to avoid page reload
        fetch('/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams(new FormData(form)).toString()
        }).then(function () {
          showSuccess();
        }).catch(function () {
          showSuccess(); // Show success anyway — Shopify sometimes returns non-200 but still subscribes
        });
      });
    }

    function showSuccess() {
      var formWrap = popup.querySelector('[data-popup-form-state="default"]');
      var successEl = popup.querySelector('[data-popup-success]');
      if (formWrap) formWrap.hidden = true;
      if (successEl) successEl.hidden = false;
      // Auto-close after 6 seconds on success
      setTimeout(function () { closePopup(true); }, 6000);
    }

    /* ── Discount code copy ──────────────────────────────────────────────── */
    var copyBtn = popup.querySelector('[data-copy-code]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = copyBtn.getAttribute('data-copy-code');
        navigator.clipboard.writeText(code).then(function () {
          var confirm = popup.querySelector('.newsletter-popup__copy-confirm');
          if (confirm) {
            confirm.textContent = copyBtn.dataset.copiedText || 'Copied!';
            setTimeout(function () { confirm.textContent = ''; }, 2500);
          }
        }).catch(function () {
          // Fallback for older browsers
          var temp = document.createElement('textarea');
          temp.value = code;
          document.body.appendChild(temp);
          temp.select();
          document.execCommand('copy');
          document.body.removeChild(temp);
        });
      });
    }

  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const el = document.querySelector('[data-product-recommendations]');
    if (!el) return;
    const url = el.dataset.url;
    if (!url) return;

    let loaded = false;
    function load() {
      if (loaded) return;
      loaded = true;
      fetch(url)
        .then((res) => res.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const fresh = html.querySelector('[data-product-recommendations]');
          if (fresh && fresh.innerHTML.trim().length) {
            el.innerHTML = fresh.innerHTML;
          }
        })
        .catch(() => {});
    }

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            load();
            io.disconnect();
          }
        });
      }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(el);
    } else {
      load();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-x-line"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-xline]');
  if (!root) return;

  function jsonFrom(sel) {
    var el = root.parentNode.querySelector(sel) || document.querySelector(sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  var variants = jsonFrom('[data-xline-variants]') || [];
  var media    = jsonFrom('[data-xline-media]') || [];
  var prices   = jsonFrom('[data-xline-prices]') || {};

  var form       = root.querySelector('[data-xline-form]');
  var variantInp = root.querySelector('[data-xline-variant-id]');
  var priceEl    = root.querySelector('[data-xline-price]');
  var compareEl  = root.querySelector('[data-xline-compare]');
  var addBtn     = root.querySelector('[data-xline-add]');
  var addLabel   = root.querySelector('[data-xline-add-label]');
  var mainImg    = root.querySelector('[data-xline-main]');
  var colourEls  = root.querySelectorAll('[data-xline-colour]');

  var swipeLabel = root.dataset.swipeLabel || 'Swipe to Add';
  var i18nSold   = root.dataset.i18nSoldout || 'Sold out';
  var i18nUnavail= root.dataset.i18nUnavailable || 'Unavailable';
  var colorIndex = parseInt(root.dataset.colorOptionIndex, 10);
  if (isNaN(colorIndex)) colorIndex = -1;

  var selected = {};
  root.querySelectorAll('[data-xline-option-index]').forEach(function (b) {
    if (b.getAttribute('aria-pressed') === 'true') {
      selected[b.dataset.xlineOptionIndex] = b.dataset.xlineOptionValue;
    }
  });

  function findVariant() {
    var vals = Object.keys(selected).sort(function (a, b) { return a - b; }).map(function (k) { return selected[k]; });
    return variants.find(function (v) {
      return v.options.length === vals.length && v.options.every(function (o, i) { return o === vals[i]; });
    });
  }

  function setImageById(mediaId) {
    if (!mainImg || !mediaId) return;
    var m = media.find(function (x) { return x.id === mediaId; });
    if (m) {
      mainImg.src = m.src; mainImg.alt = m.alt;
      var i = media.indexOf(m);
      root.querySelectorAll('[data-xline-thumb]').forEach(function (t) {
        t.classList.toggle('on', parseInt(t.dataset.xlineThumb, 10) === i);
      });
    }
  }

  function refresh(variant) {
    var info = variant ? prices[variant.id] : null;
    if (priceEl && info) priceEl.textContent = info.price;
    if (compareEl) {
      if (info && info.compare) { compareEl.textContent = info.compare; compareEl.hidden = false; }
      else { compareEl.hidden = true; }
    }
    if (addBtn && addLabel) {
      if (!variant) { addBtn.disabled = true; addLabel.textContent = i18nUnavail; }
      else if (!variant.available) { addBtn.disabled = true; addLabel.textContent = i18nSold; }
      else { addBtn.disabled = false; addLabel.textContent = swipeLabel + ' — ' + (info ? info.price : ''); }
    }
    if (variant && variantInp) variantInp.value = variant.id;
    if (variant && variant.featured_image) setImageById(variant.featured_image.id);
  }

  root.querySelectorAll('[data-xline-option-value]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var idx = btn.dataset.xlineOptionIndex;
      var val = btn.dataset.xlineOptionValue;
      root.querySelectorAll('[data-xline-option-index="' + idx + '"]').forEach(function (b) {
        b.classList.remove('on'); b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('on'); btn.setAttribute('aria-pressed', 'true');
      selected[idx] = val;
      var lbl = root.querySelector('[data-xline-selected="' + idx + '"]');
      if (lbl) lbl.textContent = val;
      if (parseInt(idx, 10) === colorIndex) {
        colourEls.forEach(function (c) { c.textContent = val; });
      }
      var variant = findVariant();
      refresh(variant);
      if (variant) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    });
  });

  root.querySelectorAll('[data-xline-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      var i = parseInt(t.dataset.xlineThumb, 10);
      var m = media[i];
      if (m && mainImg) { mainImg.src = m.src; mainImg.alt = m.alt; }
      root.querySelectorAll('[data-xline-thumb]').forEach(function (x) { x.classList.remove('on'); });
      t.classList.add('on');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-product-section]');
    if (!section) return;

    // ── Data ──────────────────────────────────────────────────────────────
    var variantsEl = document.getElementById('product-variants-json');
    var mediaEl    = document.getElementById('product-media-json');
    if (!variantsEl) return;

    var variants    = JSON.parse(variantsEl.textContent);
    var mediaItems  = mediaEl ? JSON.parse(mediaEl.textContent) : [];

    var form        = section.querySelector('[data-product-form]');
    var variantInput = form ? form.querySelector('[data-variant-id]') : null;
    var priceEl     = section.querySelector('[data-price]');
    var comparePriceEl = section.querySelector('[data-compare-price]');
    var addBtn      = section.querySelector('[data-add-to-cart]');
    var mainImg     = section.querySelector('[data-main-img]');
    var thumbBtns   = section.querySelectorAll('[data-thumb-index]');

    // ── Mobile sticky add-to-cart bar ─────────────────────────────────────
    // Shown only while the real Add to cart button sits above the viewport.
    var stickyBar = section.querySelector('[data-sticky-bar]');
    if (stickyBar && addBtn && 'IntersectionObserver' in window) {
      var stickyBtn   = stickyBar.querySelector('[data-sticky-atc]');
      var stickyPrice = stickyBar.querySelector('[data-sticky-price]');
      var stickyIO = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', show);
        stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }, { threshold: 0 });
      stickyIO.observe(addBtn);
      stickyBtn.addEventListener('click', function () { addBtn.click(); });
      var syncSticky = function () {
        if (priceEl && stickyPrice) stickyPrice.innerHTML = priceEl.innerHTML;
        stickyBtn.disabled = addBtn.disabled;
        stickyBtn.setAttribute('aria-disabled', addBtn.disabled ? 'true' : 'false');
        stickyBtn.textContent = addBtn.textContent.trim();
      };
      var stickyMO = new MutationObserver(syncSticky);
      stickyMO.observe(addBtn, { attributes: true, attributeFilter: ['disabled'], childList: true, characterData: true, subtree: true });
      if (priceEl) stickyMO.observe(priceEl, { childList: true, characterData: true, subtree: true });
    }

    // Track selected options: { optionIndex: value, ... }
    var selectedOptions = {};

    // Initialise from currently selected option buttons
    section.querySelectorAll('[data-option-index]').forEach(function (btn) {
      if (btn.classList.contains('is-selected')) {
        var idx = btn.dataset.optionIndex;
        selectedOptions[idx] = btn.dataset.optionValue;
      }
    });

    // ── Colour → media grouping ───────────────────────────────────────────
    // A media item belongs to a colour if it's a variant's featured image
    // (native association) OR its alt text contains a colour value (merchant
    // convention for multiple photos per colour). Untagged media is "shared"
    // and shown for every colour, so this degrades gracefully.
    var colorIndex = parseInt(section.dataset.colorOptionIndex);
    if (isNaN(colorIndex)) colorIndex = -1;

    var colorValues   = [];
    var mediaColorMap = {};
    if (colorIndex >= 0) {
      variants.forEach(function (v) {
        var c = v.options[colorIndex];
        if (c && colorValues.indexOf(c) === -1) colorValues.push(c);
      });
      var mcEl = document.getElementById('product-media-colors-json');
      if (mcEl) {
        try { mediaColorMap = JSON.parse(mcEl.textContent); } catch (e) { mediaColorMap = {}; }
      }
    }

    var currentColor = (colorIndex >= 0 && selectedOptions[colorIndex]) ? selectedOptions[colorIndex] : null;

    // Alt text containing "(all colours" marks a colour-agnostic detail shot
    // (interior, wheels, lock …) that is shown under every colour, after the
    // colour's own photos. "(all colours, shown in Green)" adds a caption so
    // the shopper knows the photographed shell is a different colour.
    var sharedRe = /\(all colou?rs?/i;
    var shownInLabel = section.dataset.shownInLabel || 'Shown in %color%';
    function isSharedMedia(alt) { return !!(alt && sharedRe.test(alt)); }
    function sharedShownIn(alt) {
      var m = alt && alt.match(/shown in ([^)\],]+)/i);
      return m ? m[1].trim() : '';
    }

    function galleryColorOf(mediaId, alt) {
      if (isSharedMedia(alt)) return '';
      var byVariant = mediaColorMap[String(mediaId)];
      if (byVariant) return byVariant;
      if (alt) {
        var lower = alt.toLowerCase();
        for (var i = 0; i < colorValues.length; i++) {
          if (lower.indexOf(colorValues[i].toLowerCase()) !== -1) return colorValues[i];
        }
      }
      return '';
    }

    // ── Find matching variant ─────────────────────────────────────────────
    function findVariant() {
      var optionValues = Object.values(selectedOptions);
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return opt === optionValues[i];
        });
      });
    }

    // ── Update price display ──────────────────────────────────────────────
    function formatMoney(cents) {
      return window.Theme.formatMoney(cents);
    }

    function updatePrice(variant) {
      if (!variant) return;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      // Unit price (only present when the product uses unit price measurements)
      var unitPriceRow = section.querySelector('[data-unit-price-row]');
      if (unitPriceRow) {
        var unitPriceEl = unitPriceRow.querySelector('[data-unit-price]');
        if (variant.unit_price != null && unitPriceEl) {
          unitPriceEl.textContent = formatMoney(variant.unit_price);
          unitPriceRow.style.display = '';
        } else if (variant.unit_price == null) {
          unitPriceRow.style.display = 'none';
        }
      }
    }

    // ── i18n strings injected via data attributes on [data-product-section]
    var i18nAddToCart  = section.dataset.i18nAddToCart  || 'Add to cart';
    var i18nPreorder   = section.dataset.i18nPreorder   || 'Preorder now';
    var i18nSoldOut    = section.dataset.i18nSoldOut    || 'Sold out';
    var i18nUnavailable = section.dataset.i18nUnavailable || 'Unavailable';
    var isPreorder     = section.dataset.isPreorder === 'true';

    // ── Update add-to-cart button ─────────────────────────────────────────
    function updateAddBtn(variant) {
      if (!addBtn) return;
      if (!variant || !variant.available) {
        addBtn.disabled = true;
        addBtn.setAttribute('aria-disabled', 'true');
        addBtn.textContent = variant ? i18nSoldOut : i18nUnavailable;
      } else {
        addBtn.disabled = false;
        addBtn.removeAttribute('aria-disabled');
        addBtn.textContent = isPreorder ? i18nPreorder : i18nAddToCart;
      }
    }

    // ── Update variant image ──────────────────────────────────────────────
    function updateVariantImage(variant) {
      if (!variant || !variant.featured_image || !mainImg) return;
      var mediaId = variant.featured_image.id;
      var media = mediaItems.find(function (m) { return m.id === mediaId; });
      var activeIdx = null;
      thumbBtns.forEach(function (b, i) {
        if (b.dataset.mediaId && String(b.dataset.mediaId) === String(mediaId)) activeIdx = i;
      });
      if (media) setMainImage(media.src, media.alt, activeIdx);
    }

    // ── Update unavailable option states ──────────────────────────────────
    function updateOptionAvailability() {
      var optionGroups = section.querySelectorAll('[data-option-index]');
      var processedIndexes = new Set();

      optionGroups.forEach(function (btn) {
        var idx = parseInt(btn.dataset.optionIndex);
        if (processedIndexes.has(idx)) return;
        processedIndexes.add(idx);

        // For each value in this option, check if any variant with it is available
        var valueBtns = section.querySelectorAll('[data-option-index="' + idx + '"]');
        valueBtns.forEach(function (vBtn) {
          var testOptions = Object.assign({}, selectedOptions);
          testOptions[idx] = vBtn.dataset.optionValue;
          var optionValues = Object.values(testOptions);

          var isAvailable = variants.some(function (v) {
            return v.available && v.options.every(function (opt, i) {
              return opt === optionValues[i];
            });
          });

          vBtn.dataset.unavailable = isAvailable ? '' : 'true';
          if (!isAvailable) {
            vBtn.setAttribute('disabled', '');
          } else {
            vBtn.removeAttribute('disabled');
          }
        });
      });
    }

    // ── On option select ──────────────────────────────────────────────────
    function onOptionSelect(btn) {
      var idx = btn.dataset.optionIndex;
      var value = btn.dataset.optionValue;

      // Update selection state
      section.querySelectorAll('[data-option-index="' + idx + '"]').forEach(function (b) {
        b.classList.remove('is-selected');
        b.setAttribute('aria-pressed', 'false');
        b.setAttribute('aria-label', b.dataset.optionValue);
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');
      btn.setAttribute('aria-label', value + ' (selected)');

      // Update selected value label
      var labelEl = section.querySelector('[data-selected-value="' + idx + '"]');
      if (labelEl) labelEl.textContent = value;

      selectedOptions[idx] = value;

      var variant = findVariant();
      if (variant && variantInput) variantInput.value = variant.id;

      updatePrice(variant);
      updateAddBtn(variant);
      updateVariantImage(variant);
      if (colorIndex >= 0 && parseInt(idx) === colorIndex) {
        applyColorFilter(value);
        // Warm the rest of this colour so its thumbnails step instantly too.
        onIdle(function () { warmColor(value); });
      }
      updateOptionAvailability();
      updateStockCounter(variant);

      // Update URL without reload
      if (variant) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    section.querySelectorAll('[data-option-value]').forEach(function (btn) {
      btn.addEventListener('click', function () { onOptionSelect(btn); });

      // Warm this colour's gallery on hover / touch-down. The ~150ms before
      // the click lands is usually enough to cover the fetch, so by the time
      // the swap runs there is nothing left to wait on.
      if (colorIndex >= 0 && parseInt(btn.dataset.optionIndex) === colorIndex) {
        var warm = function () { warmColor(btn.dataset.optionValue); };
        btn.addEventListener('pointerenter', warm, { passive: true });
        btn.addEventListener('touchstart', warm, { passive: true });
      }
    });

    // ── Image gallery ─────────────────────────────────────────────────────
    // Thumbnail rail: capped at the main-image height on desktop; these keep
    // the active thumb visible and toggle the edge-fade hint classes.
    var thumbRail = section.querySelector('[data-product-thumbnails]');

    function updateRailFades() {
      if (!thumbRail) return;
      var scrollable = thumbRail.scrollHeight > thumbRail.clientHeight + 4;
      thumbRail.classList.toggle('rail-fade-top', scrollable && thumbRail.scrollTop > 4);
      thumbRail.classList.toggle(
        'rail-fade-bottom',
        scrollable && thumbRail.scrollTop + thumbRail.clientHeight < thumbRail.scrollHeight - 4
      );
    }

    function scrollThumbIntoView(btn) {
      if (!thumbRail || !btn || thumbRail.scrollHeight <= thumbRail.clientHeight + 4) return;
      var top = btn.offsetTop - thumbRail.offsetTop;
      var bottom = top + btn.offsetHeight;
      if (top < thumbRail.scrollTop + 8) {
        thumbRail.scrollTop = top - 8;
      } else if (bottom > thumbRail.scrollTop + thumbRail.clientHeight - 8) {
        thumbRail.scrollTop = bottom - thumbRail.clientHeight + 8;
      }
    }

    if (thumbRail) {
      thumbRail.addEventListener('scroll', updateRailFades, { passive: true });
      window.addEventListener('resize', updateRailFades);
      updateRailFades();
    }

    // ── Mobile swipe gallery ───────────────────────────────────────────────
    // Phones swipe a scroll-snap track instead of tapping thumbs one by one.
    // Kept in sync both ways: swiping highlights the matching thumb; thumb /
    // variant / colour changes scroll the track to the right slide.
    var mobileTrack  = section.querySelector('[data-mobile-track]');
    var mobileSlides = mobileTrack
      ? Array.prototype.slice.call(mobileTrack.querySelectorAll('[data-mobile-slide]'))
      : [];

    function mobileVisibleSlides() {
      return mobileSlides.filter(function (s) { return !s.hidden; });
    }

    function mobileNearestSlide() {
      var center = mobileTrack.scrollLeft + mobileTrack.clientWidth / 2;
      var best = null;
      var bestDist = Infinity;
      mobileVisibleSlides().forEach(function (s) {
        var d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - center);
        if (d < bestDist) { bestDist = d; best = s; }
      });
      return best;
    }

    function mobileScrollToMedia(mediaId) {
      if (!mobileTrack || !mobileTrack.clientWidth || !mediaId) return;
      for (var i = 0; i < mobileSlides.length; i++) {
        var s = mobileSlides[i];
        if (!s.hidden && s.dataset.mediaId === String(mediaId)) {
          mobileTrack.scrollTo({ left: s.offsetLeft, behavior: 'smooth' });
          return;
        }
      }
    }

    if (mobileTrack) {
      // Swipe → highlight the matching thumb once scrolling settles
      var mobileScrollTimer = null;
      mobileTrack.addEventListener('scroll', function () {
        clearTimeout(mobileScrollTimer);
        mobileScrollTimer = setTimeout(function () {
          var slide = mobileNearestSlide();
          if (!slide) return;
          currentIdx = parseInt(slide.dataset.mobileSlide) || 0;
          thumbBtns.forEach(function (b) {
            b.classList.toggle('is-active', b.dataset.mediaId === slide.dataset.mediaId);
          });
        }, 90);
      }, { passive: true });

      // Arrows step one visible slide at a time
      function mobileStep(dir) {
        var visible = mobileVisibleSlides();
        var current = mobileNearestSlide();
        var idx = visible.indexOf(current);
        var next = visible[Math.max(0, Math.min(visible.length - 1, idx + dir))];
        if (next) mobileTrack.scrollTo({ left: next.offsetLeft, behavior: 'smooth' });
      }

      var mobilePrev = section.querySelector('[data-mobile-prev]');
      var mobileNext = section.querySelector('[data-mobile-next]');
      mobilePrev && mobilePrev.addEventListener('click', function () { mobileStep(-1); });
      mobileNext && mobileNext.addEventListener('click', function () { mobileStep(1); });

      // Tap a slide → open the lightbox on that image
      mobileSlides.forEach(function (s) {
        s.addEventListener('click', function () {
          openLightbox(parseInt(s.dataset.mobileSlide) || 0);
        });
      });
    }

    // ── Desktop main-image arrows ──────────────────────────────────────────
    // Steps through the visible image thumbs (so the colour filter is
    // respected) by re-using the thumb's own click handling.
    function mainImageStep(dir) {
      var imgs = Array.prototype.filter.call(thumbBtns, function (b) {
        return (b.dataset.thumbType || 'image') === 'image' && !b.hidden;
      });
      if (imgs.length < 2) return;
      var cur = 0;
      for (var i = 0; i < imgs.length; i++) {
        if (imgs[i].classList.contains('is-active')) { cur = i; break; }
      }
      var next = (cur + dir + imgs.length) % imgs.length;
      imgs[next].click();
    }

    section.querySelectorAll('[data-main-nav]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        mainImageStep(parseInt(btn.dataset.mainNav) || 1);
      });
    });

    var mainImgToken = 0;

    // The main <img> ships a width-based srcset, and a browser renders from
    // srcset whenever it is present, ignoring src. So every swap must rewrite
    // srcset too, or the colour changes while the picture does not.
    var MAIN_WIDTHS = [480, 720, 960, 1200];
    function srcsetFor(src) {
      if (!/[?&]width=\d+/.test(src)) return '';
      return MAIN_WIDTHS.map(function (w) {
        return src.replace(/([?&]width=)\d+/, '$1' + w) + ' ' + w + 'w';
      }).join(', ');
    }

    function setMainImage(src, alt, activeThumbIndex) {
      if (!mainImg) return;
      if (videoWrap && !videoWrap.hidden) hideVideoPlayer();

      // Swap only once the new image is decoded — cached images apply
      // instantly, uncached ones keep the old image without a blank flash.
      // The token drops stale decodes when the user clicks quickly.
      var token = ++mainImgToken;
      var wrap = mainImgWrap || section.querySelector('[data-product-main-image]');

      // A warmed image decodes well inside this window, so the spinner never
      // flashes on the common path. Past it the wait is real and the gallery
      // would otherwise look frozen — dim the outgoing image and spin.
      var slowTimer = setTimeout(function () {
        if (token === mainImgToken && wrap) wrap.classList.add('is-loading');
      }, 150);

      var apply = function () {
        clearTimeout(slowTimer);
        if (token !== mainImgToken) return;
        if (wrap) wrap.classList.remove('is-loading');
        if (srcset) mainImg.setAttribute('srcset', srcset);
        else mainImg.removeAttribute('srcset');
        mainImg.setAttribute('src', src);
        mainImg.setAttribute('alt', alt || '');
        // "Shown in <colour>" caption for shared detail shots
        if (wrap) {
          var shownIn = sharedShownIn(alt);
          var note = wrap.querySelector('[data-shown-in]');
          if (shownIn && !note) {
            note = document.createElement('span');
            note.className = 'product__shown-in product__shown-in--main';
            note.setAttribute('data-shown-in', '');
            wrap.appendChild(note);
          }
          if (note) {
            note.textContent = shownIn ? shownInLabel.replace('%color%', shownIn) : '';
            note.hidden = !shownIn;
          }
        }
      };
      // Preload the same candidate the <img> will pick, so the swap is instant
      var srcset = srcsetFor(src);
      var pre = new Image();
      if (srcset) {
        pre.sizes = mainImg.getAttribute('sizes') || '100vw';
        pre.srcset = srcset;
      }
      pre.src = src;
      if (pre.decode) { pre.decode().then(apply, apply); } else { apply(); }

      if (activeThumbIndex !== null) {
        thumbBtns.forEach(function (t, i) {
          t.classList.toggle('is-active', i === activeThumbIndex);
        });
        var activeBtn = thumbBtns[activeThumbIndex];
        if (activeBtn) {
          scrollThumbIntoView(activeBtn);
          mobileScrollToMedia(activeBtn.dataset.mediaId);
        }
      }
    }

    // ── Filter gallery to the selected colour ─────────────────────────────
    // Hides thumbnails + lightbox images that belong to other colours.
    // Shared (untagged) media and videos stay visible. visibleLbIndices is
    // consumed by the lightbox navigation so it only cycles shown images.
    var visibleLbIndices = null;

    function applyColorFilter(color) {
      if (colorIndex < 0) return;
      currentColor = color || null;

      // Thumbnails (leave videos alone)
      var activeHidden = false;
      thumbBtns.forEach(function (btn) {
        if ((btn.dataset.thumbType || 'image') !== 'image') return;
        var innerImg = btn.querySelector('img');
        var innerAlt = innerImg ? innerImg.alt : '';
        var gc = galleryColorOf(btn.dataset.mediaId, innerAlt);
        var show = !currentColor || gc === '' || gc === currentColor;
        btn.hidden = !show;
        // Shared detail shots sit after the colour's own photos
        var shared = isSharedMedia(innerAlt);
        btn.classList.toggle('is-shared', shared);
        btn.style.order = (shared && currentColor) ? '1' : '';
        if (!show && btn.classList.contains('is-active')) activeHidden = true;
      });

      // Mobile swipe slides follow the same colour filter (before the
      // active-thumb jump below, so it can scroll to a now-visible slide)
      mobileSlides.forEach(function (s) {
        var im = s.querySelector('img');
        var sAlt = im ? im.getAttribute('alt') : '';
        var gc = galleryColorOf(s.dataset.mediaId, sAlt);
        s.hidden = !(!currentColor || gc === '' || gc === currentColor);
        s.style.order = (isSharedMedia(sAlt) && currentColor) ? '1' : '';
      });

      // Lightbox images (it may have been portaled to <body>, so don't
      // scope the lookup to the section).
      var lb = document.getElementById('product-lightbox') || section.querySelector('[data-lightbox]');
      visibleLbIndices = [];
      if (lb) {
        var lbOwn = [], lbShared = [];
        lb.querySelectorAll('[data-lightbox-img]').forEach(function (img) {
          var lbAlt = img.getAttribute('alt');
          var gc = galleryColorOf(img.dataset.mediaId, lbAlt);
          if (!currentColor || gc === '' || gc === currentColor) {
            (currentColor && isSharedMedia(lbAlt) ? lbShared : lbOwn).push(parseInt(img.dataset.lightboxImg));
          }
        });
        visibleLbIndices = lbOwn.concat(lbShared);
      }

      // If the active thumb was hidden, jump the main image to the first shown
      // one, preferring the colour's own photo over a shared detail shot
      if (activeHidden) {
        var jumpTo = null;
        for (var pass = 0; pass < 2 && !jumpTo; pass++) {
          for (var i = 0; i < thumbBtns.length; i++) {
            var b = thumbBtns[i];
            if ((b.dataset.thumbType || 'image') !== 'image' || b.hidden) continue;
            if (pass === 0 && b.classList.contains('is-shared')) continue;
            jumpTo = b;
            break;
          }
        }
        if (jumpTo) {
          var jim = jumpTo.querySelector('img');
          setMainImage(jumpTo.dataset.thumbSrc, jim ? jim.alt : '', parseInt(jumpTo.dataset.thumbIndex));
        }
      }

      // Keep the lightbox starting point on a visible image.
      if (visibleLbIndices && visibleLbIndices.length) currentIdx = visibleLbIndices[0];

      // Hidden thumbs change the rail's scroll range
      updateRailFades();
    }

    // ── Preload gallery images ────────────────────────────────────────────
    // A cold 1200px image costs ~700-900ms on its first request (Shopify
    // generates the derivative at the origin), and setMainImage holds the
    // outgoing image on screen for that whole time — so any URL that isn't
    // already warm reads as a frozen gallery. Warming happens in three tiers,
    // all off the critical path:
    //   1. one image per colour        → swatch clicks are instant
    //   2. the rest of the shown colour → stepping its thumbnails is instant
    //   3. on swatch hover/touch        → covers a click that lands before
    //                                     tier 1 has had a chance to run
    var warmed = {};

    function warmUrl(u) {
      if (!u || warmed[u]) return;
      warmed[u] = true;
      var img = new Image();
      img.decoding = 'async';
      img.src = u;
    }

    function onIdle(fn) {
      if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: 3000 });
      else setTimeout(fn, 1200);
    }

    // Every gallery image belonging to `color`, shared/untagged media included.
    function warmColor(color) {
      thumbBtns.forEach(function (b) {
        if ((b.dataset.thumbType || 'image') !== 'image' || !b.dataset.thumbSrc) return;
        var im = b.querySelector('img');
        var gc = galleryColorOf(b.dataset.mediaId, im ? im.alt : '');
        if (!color || gc === '' || gc === color) warmUrl(b.dataset.thumbSrc);
      });
    }

    function preloadColorImages() {
      variants.forEach(function (v) {
        if (!v.featured_image) return;
        var m = mediaItems.find(function (mi) { return mi.id === v.featured_image.id; });
        if (m) warmUrl(m.src);
      });
      var seen = {};
      thumbBtns.forEach(function (b) {
        if ((b.dataset.thumbType || 'image') !== 'image' || !b.dataset.thumbSrc) return;
        var im = b.querySelector('img');
        var gc = galleryColorOf(b.dataset.mediaId, im ? im.alt : '');
        if (gc && !seen[gc]) {
          seen[gc] = true;
          warmUrl(b.dataset.thumbSrc);
        }
      });
    }

    onIdle(function () {
      preloadColorImages();
      onIdle(function () { warmColor(currentColor); });
    });

    var videoWrap = section.querySelector('[data-product-video-wrap]');
    var videoBack = section.querySelector('[data-video-back]');
    var mainImgWrap = section.querySelector('[data-product-main-image]');

    function showVideoPlayer(mediaId) {
      if (!videoWrap) return;
      // Hide all video players, show the right one
      videoWrap.querySelectorAll('[data-video-player]').forEach(function (p) { p.hidden = true; });
      var player = videoWrap.querySelector('[data-video-player="' + mediaId + '"]');
      if (player) {
        player.hidden = false;
        // Autoplay native video
        var vid = player.querySelector('video');
        if (vid) vid.play().catch(function () {});
      }
      videoWrap.hidden = false;
      mainImgWrap.style.visibility = 'hidden';
    }

    function hideVideoPlayer() {
      if (!videoWrap) return;
      videoWrap.querySelectorAll('video').forEach(function (v) { v.pause(); });
      videoWrap.hidden = true;
      mainImgWrap.style.visibility = '';
    }

    videoBack && videoBack.addEventListener('click', function () {
      hideVideoPlayer();
      // Restore active thumb visual
      thumbBtns.forEach(function (b) { b.classList.remove('is-active'); });
    });

    thumbBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var type = btn.dataset.thumbType || 'image';
        var idx  = parseInt(btn.dataset.thumbIndex);

        thumbBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');

        if (type === 'video' || type === 'external_video') {
          showVideoPlayer(btn.dataset.mediaId);
        } else {
          hideVideoPlayer();
          // mediaItems holds images only — use the image index, which skips
          // any videos mixed into the thumb list
          var imgIdx = btn.dataset.imageIndex != null ? parseInt(btn.dataset.imageIndex) : idx;
          var media = mediaItems[imgIdx];
          if (media) setMainImage(media.src, media.alt, idx);
        }
      });
    });

    // ── Quantity selector ─────────────────────────────────────────────────
    var qtyInput  = section.querySelector('.quantity-selector__input');
    var qtyMinus  = section.querySelector('[data-qty-minus]');
    var qtyPlus   = section.querySelector('[data-qty-plus]');

    if (qtyInput) {
      qtyMinus?.addEventListener('click', function () {
        var val = parseInt(qtyInput.value) || 1;
        if (val > 1) qtyInput.value = val - 1;
      });
      qtyPlus?.addEventListener('click', function () {
        var val = parseInt(qtyInput.value) || 1;
        qtyInput.value = val + 1;
      });
      qtyInput.addEventListener('change', function () {
        var val = parseInt(qtyInput.value);
        if (isNaN(val) || val < 1) qtyInput.value = 1;
      });
    }

    // ── Size guide modal ──────────────────────────────────────────────────
    var sizeGuideModal = document.querySelector('[data-size-guide-modal]');
    var openSizeGuide  = section.querySelector('[data-open-size-guide]');
    var closeSizeGuide = document.querySelector('[data-close-size-guide]');

    openSizeGuide?.addEventListener('click', function () {
      sizeGuideModal?.showModal();
    });
    closeSizeGuide?.addEventListener('click', function () {
      sizeGuideModal?.close();
    });
    sizeGuideModal?.addEventListener('click', function (e) {
      if (e.target === sizeGuideModal) sizeGuideModal.close();
    });

    // ── Stock counter ─────────────────────────────────────────────────────
    var lowStockThreshold = parseInt(section.dataset.lowStockThreshold) || 5;
    var stockCounter = section.querySelector('[data-stock-counter]');
    var stockLabel   = section.querySelector('[data-stock-label]');

    function updateStockCounter(variant) {
      if (!stockCounter || !variant) return;
      var qty = variant.inventory_quantity;
      var managed = variant.inventory_management;

      if (!managed || qty === null) {
        stockCounter.style.display = 'none';
        return;
      }

      stockCounter.style.display = '';
      var bar = stockCounter.querySelector('.product__stock-bar-fill');

      if (qty <= 0) {
        stockCounter.style.display = 'none';
      } else if (qty <= lowStockThreshold) {
        if (stockLabel) {
          stockLabel.className = 'product__stock-label product__stock-label--low';
          stockLabel.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="12" cy="12" r="10"/></svg> Only ' + qty + ' left \u2014 selling fast';
        }
        if (bar) {
          bar.className = 'product__stock-bar-fill product__stock-bar-fill--low';
          bar.style.width = Math.min(100, Math.round(qty / lowStockThreshold * 100)) + '%';
        }
      } else {
        if (stockLabel) {
          stockLabel.className = 'product__stock-label';
          stockLabel.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="12" cy="12" r="10"/></svg> In stock';
        }
        if (bar) {
          bar.className = 'product__stock-bar-fill';
          bar.style.width = '100%';
        }
      }
    }

    // ── Init: check availability for initial state ────────────────────────
    updateOptionAvailability();

    // ── Lightbox ──────────────────────────────────────────────────────────
    var lightbox   = section.querySelector('[data-lightbox]');
    if (!lightbox) return;

    var lbImgs     = lightbox.querySelectorAll('[data-lightbox-img]');
    var lbCounter  = lightbox.querySelector('[data-lightbox-counter]');
    var lbPrev     = lightbox.querySelector('[data-lightbox-prev]');
    var lbNext     = lightbox.querySelector('[data-lightbox-next]');
    var totalImgs  = lbImgs.length;
    var currentIdx = 0;

    // Absolute indices currently shown (respects colour filtering).
    function lbVisible() {
      if (visibleLbIndices && visibleLbIndices.length) return visibleLbIndices;
      var all = [];
      for (var i = 0; i < totalImgs; i++) all.push(i);
      return all;
    }

    function showLbImg(absIdx) {
      var vis = lbVisible();
      if (!vis.length) return;
      if (vis.indexOf(absIdx) === -1) absIdx = vis[0];
      lbImgs.forEach(function (img, i) {
        img.style.display = i === absIdx ? 'block' : 'none';
      });
      currentIdx = absIdx;
      var pos = vis.indexOf(absIdx);
      if (lbCounter) lbCounter.textContent = (pos + 1) + ' / ' + vis.length;
      var multi = vis.length > 1;
      if (lbPrev) lbPrev.hidden = !multi;
      if (lbNext) lbNext.hidden = !multi;
    }

    function lbStep(dir) {
      var vis = lbVisible();
      if (!vis.length) return;
      var pos = vis.indexOf(currentIdx);
      if (pos === -1) pos = 0;
      pos = (pos + dir + vis.length) % vis.length;
      showLbImg(vis[pos]);
    }

    function openLightbox(idx) {
      // Portal to <body> so the fixed overlay escapes any ancestor stacking
      // context — notably the theme editor wraps each section in a
      // transformed element, which would otherwise trap the overlay behind
      // the header and product info.
      if (lightbox.parentNode !== document.body) document.body.appendChild(lightbox);
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      showLbImg(idx || 0);
    }

    function closeLightbox() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    // Open on zoom button click
    section.querySelectorAll('[data-lightbox-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openLightbox(parseInt(btn.dataset.lightboxOpen) || 0);
      });
    });

    // Sync lightbox with thumbnail changes (image thumbs only — the lightbox
    // indexes over images, so videos must not move it)
    thumbBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.dataset.imageIndex != null) currentIdx = parseInt(btn.dataset.imageIndex) || 0;
      });
    });

    // Controls
    lightbox.querySelector('[data-lightbox-close]').addEventListener('click', closeLightbox);
    lbPrev && lbPrev.addEventListener('click', function () { lbStep(-1); });
    lbNext && lbNext.addEventListener('click', function () { lbStep(1); });

    // Close on backdrop click
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target === lightbox.querySelector('[data-lightbox-img-wrap]')) closeLightbox();
    });

    // Keyboard nav
    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape')     closeLightbox();
      if (e.key === 'ArrowLeft')  lbStep(-1);
      if (e.key === 'ArrowRight') lbStep(1);
    });

    // Touch swipe support
    var touchStartX = 0;
    lightbox.addEventListener('touchstart', function (e) { touchStartX = e.changedTouches[0].screenX; }, { passive: true });
    lightbox.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].screenX - touchStartX;
      if (Math.abs(dx) > 40) lbStep(dx < 0 ? 1 : -1);
    }, { passive: true });

    // ── Init: filter gallery to the initially selected colour ─────────────
    if (colorIndex >= 0 && currentColor) applyColorFilter(currentColor);

    // ── Gift card recipient form toggle ──────────────────────────────────
    var recipientCheckbox = section.querySelector('[data-recipient-checkbox]');
    var recipientFields   = section.querySelector('[data-recipient-fields]');
    if (recipientCheckbox && recipientFields) {
      var recipientOffset = recipientFields.querySelector('[data-recipient-offset]');
      recipientCheckbox.addEventListener('change', function () {
        var on = recipientCheckbox.checked;
        recipientFields.hidden = !on;
        recipientFields.querySelectorAll('input, textarea').forEach(function (el) {
          el.disabled = !on;
        });
        if (on && recipientOffset) {
          recipientOffset.value = new Date().getTimezoneOffset().toString();
        }
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  var popup   = document.querySelector('[data-promo-popup]');
  if (!popup) return;

  var id        = popup.dataset.popupId;
  var delay     = parseInt(popup.dataset.delay) || 3000;
  var frequency = popup.dataset.frequency || 'session';
  var KEY       = 'fortuneo-popup-' + id;

  /* Check if already dismissed */
  var store = frequency === 'day' ? localStorage : sessionStorage;
  if (store.getItem(KEY)) return;

  /* Open after delay */
  setTimeout(function () {
    popup.showModal();
  }, delay);

  /* Close actions */
  function dismiss() {
    popup.close();
    store.setItem(KEY, '1');
  }

  document.querySelectorAll('[data-popup-close]').forEach(function (btn) {
    btn.addEventListener('click', dismiss);
  });

  popup.addEventListener('click', function (e) {
    if (e.target === popup) dismiss();
  });

  /* Copy discount code */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-popup-copy]');
    if (!btn) return;
    var codeEl = btn.closest('.promo-popup__code-wrap').querySelector('[data-popup-code]');
    var code = codeEl ? codeEl.textContent.trim() : '';
    if (!code) return;
    navigator.clipboard.writeText(code).then(function () {
      var orig = btn.textContent;
      btn.textContent = 'Copied!';
      setTimeout(function () { btn.textContent = orig; }, 2000);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
(function () {
  var el       = document.querySelector('[data-slideshow]');
  if (!el) return;

  var track    = el.querySelector('[data-slideshow-track]');
  var slides   = el.querySelectorAll('[data-slide]');
  var dots     = el.querySelectorAll('[data-slide-dot]');
  var prevBtn  = el.querySelector('[data-slideshow-prev]');
  var nextBtn  = el.querySelector('[data-slideshow-next]');
  var total    = slides.length;
  var current  = 0;
  var autoplay = el.dataset.autoplay !== 'false';
  var interval = parseInt(el.dataset.interval) || 5000;
  var timer    = null;

  if (total < 2) return;

  function goTo(index) {
    slides[current].classList.remove('is-active');
    if (dots[current]) { dots[current].classList.remove('is-active'); dots[current].setAttribute('aria-selected', 'false'); }
    current = (index + total) % total;
    track.style.transform = 'translateX(-' + (current * 100) + '%)';
    slides[current].classList.add('is-active');
    if (dots[current]) { dots[current].classList.add('is-active'); dots[current].setAttribute('aria-selected', 'true'); }
  }

  prevBtn?.addEventListener('click', function () { goTo(current - 1); resetTimer(); });
  nextBtn?.addEventListener('click', function () { goTo(current + 1); resetTimer(); });

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () { goTo(parseInt(dot.dataset.slideDot)); resetTimer(); });
  });

  /* Drag / swipe */
  var startX = 0;
  el.addEventListener('pointerdown', function (e) { startX = e.clientX; });
  el.addEventListener('pointerup', function (e) {
    var diff = startX - e.clientX;
    if (Math.abs(diff) > 40) { diff > 0 ? goTo(current + 1) : goTo(current - 1); resetTimer(); }
  });

  /* Autoplay */
  function startTimer() {
    if (!autoplay) return;
    timer = setInterval(function () { goTo(current + 1); }, interval);
  }

  function resetTimer() {
    clearInterval(timer);
    startTimer();
  }

  /* Pause on hover */
  el.addEventListener('mouseenter', function () { clearInterval(timer); });
  el.addEventListener('mouseleave', startTimer);

  startTimer();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section  = document.currentScript.closest('.shopify-section');
    if (!section) return;
    var btn   = section.querySelector('[data-sound-toggle]');
    var video = section.querySelector('.video-hero__video');
    if (!btn || !video) return;

    var iconMuted = btn.querySelector('.video-hero__sound-icon--muted');
    var iconOn    = btn.querySelector('.video-hero__sound-icon--on');

    btn.addEventListener('click', function () {
      var muted = video.muted;
      video.muted = !muted;
      btn.setAttribute('aria-pressed', muted ? 'true' : 'false');
      if (iconMuted) iconMuted.style.display = muted ? 'none' : '';
      if (iconOn)    iconOn.style.display    = muted ? ''     : 'none';
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
